import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { PromoteChannelsScreen } from './PromoteChannelsScreen';

/**
 * The Channels route `/app/promote/promoteChannels`: the Channels item of the Promote menu. It is
 * its own page, with no Settings rail (owner, 2026-10-26). Settings → Connections draws the same
 * body at `/app/settings?tab=connections`. The sign-in emails, the pushes and the OAuth return of a
 * social sign-in (`?promoConnect=&result=`) land here. Every call is account-scoped.
 */
const PromoteChannelsViewComponent: React.FC = () => {
  const accountId = useAccountId();

  if (accountId === null) {
    return <LoadingView />;
  }

  return <PromoteChannelsScreen accountId={accountId} />;
};

export const PromoteChannelsView = TypedMemo(PromoteChannelsViewComponent);
